import { useEffect, useState } from "react";
import MainDashboardContents from "../../../components/Dashboard/FundraiserRep/FundraiserRepQuickStats";
import "./FundraiserRepDashboard.css";
import ProfileBanner from "../../../components/Dashboard/ProfileBanner";
import QuickActionsSidebar from "../../MainView/QuickActionSidebar";
import FundraiserStatsTable from "../../../components/Dashboard/FundraiserRep/FundraiserStatsTable";
import { getCurrentlyLoggedInUser } from "../../../CommonFunctions";
import config from "../../../config";
import { useNavigate } from "react-router-dom";
import { RepresentativeDashboard } from "../../../Interfaces/Dashboards";
import fetchWithAuth from "../../../services/fetchWithAuth";

const RepDashboard = () => {
  const [loggedInUser, setLoggedInUser] = useState<any | null>(null);
  const [repData, setRepData] = useState<RepresentativeDashboard | null>(null);
  const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

  useEffect(() => {
    const fetchLoggedInUser = async () => {
      try{
        const user = await getCurrentlyLoggedInUser();
        setLoggedInUser(user);
      }
      catch (error){
        navigate("/login");
      }
    };

    fetchLoggedInUser();
    document.title = "Fundraiser Representative Dashboard";
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      if (!loggedInUser) return;

      const url = `${config.API_BASE_URL}dashboards/representative/`;
      try {
        const response = await fetchWithAuth(`${url}?representative_account_id=${loggedInUser.id}`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const repData: RepresentativeDashboard = await response.json();
        setRepData(repData);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, [loggedInUser]);

  return (
    <div className="fundraising-rep-dashboard-container">
      {/* Profile Banner at the top */}
      {loggedInUser && (
        <div className="fundraising-rep-dashboard-profile-banner">
          <ProfileBanner
            name={`${loggedInUser.first_name} ${loggedInUser.last_name}`}
            role="Fundraiser Rep"
            profile_pic={loggedInUser.profile_pic}
          />
        </div>
      )}

      {/* Main Content with Sidebar and Dashboard */}
      <div className="fundraising-rep-dashboard-main-layout">
        {/*  
      <div className="fundraising-rep-dashboard-sidebar">
          <QuickActionsSidebar />
        </div>
        */}
        <div className="fundraising-rep-dashboard-main-content">
          <MainDashboardContents repDashboard={repData} />
          {/* Only render the stats table when repData is populated */}
          {!isLoading && repData && (
            <FundraiserStatsTable repFundraisers={repData.fundraisers || []} />
          )}
        </div>
      </div>
    </div>
  );
};

export default RepDashboard;
